import type { ListQuery, ListQueryVariables } from '#shared/types/goliath/goliath.types';

export default async (
  params: ListQueryVariables = {},
  progress = true,
  skipCache = false,
  signal: AbortSignal | undefined = undefined
): Promise<ListQuery['offers']> => {
  const { $goliathApi } = useNuxtApp();

  return $goliathApi<ListQueryVariables, ListQuery, 'offers'>(
    'list',
    params,
    'offers',
    progress,
    skipCache,
    signal
  );
};
